const defaultFontSize = 16

export default {
  starFontSize: defaultFontSize,
  minorStarFontSize: defaultFontSize - 2,
  actionFontSize: 18,
}
